import { i18n } from '@migros/msrc-i18n';
import { ArticleHeading, Box, Stack } from '@migros/msrc-ui-kit';
import React from 'react';
import { Card } from '../../elements/card/Card';
import { ArticleMiniContainer, ArticleMiniImage } from '../../elements/tiles/partials';
import { FallbackImage } from '../fallback-image';
export const FallbackMini = ({
  hideRating,
  mode
}) => {
  return /*#__PURE__*/React.createElement(Card, {
    as: "article",
    mode: mode,
    "data-testid": "msrc-articles--fallback-mini",
    disableHover: true
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ArticleMiniContainer, {
    display: ['flex'],
    alignItems: ['center'],
    "aria-hidden": true,
    hideRating: hideRating
  }, /*#__PURE__*/React.createElement(Stack, {
    orientation: "horizontal",
    position: ['relative'],
    alignItems: ['center'],
    size: ['xsmall', 'medium']
  }, /*#__PURE__*/React.createElement(ArticleMiniImage, null, /*#__PURE__*/React.createElement(FallbackImage, null)), /*#__PURE__*/React.createElement(Stack, {
    size: ['xsmall', 'small']
  }, /*#__PURE__*/React.createElement(ArticleHeading, {
    as: "p",
    color: ['gray', 90],
    paddingY: ['medium', 'xlarge'],
    sizeFont: ['xsmall', 'small'],
    lineHeight: ['tight']
  }, i18n.t('components.fallback')))))));
};